<template>
  <Modal
    id="AttendanceLogsEdit"
    width="80%"
    :visible="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
    :zIndex="9999999900"
  >
    <Row align="middle" justify="center">
      <Col span="18" class="content">
        <Row>
          <Col span="24">
            <Form
              ref="attendanceLogsForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                <Col span="10">
                    <FormItem :label="$t('attendanceLogs.field.id_emp')" name="idEmp">
                      <!--关联表的下拉选择-->
                      <Select
                              v-model:value="form.idEmp"
                              :placeholder="$t('attendanceLogs.validate.required.id_emp')"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['employeeList']" :value="item['idEmp']">{{ item['nickName'] }}</SelectOption>
                      </Select>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('attendanceLogs.field.check_time')" name="checkTime">
                      <DatePicker show-time valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.checkTime" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                </Col>
                <Col span="10">
                    <FormItem :label="$t('attendanceLogs.field.verify_mode')" name="verifyMode">
                      <Input :placeholder="$t('attendanceLogs.validate.required.verify_mode')"
                             v-model:value="form.verifyMode">
                      </Input>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
} from "@ant-design/icons-vue";
import { AttendanceLogsAdd } from "@/api/AttendanceLogsAdd";
import { AttendanceLogsEdit } from "@/api/AttendanceLogsEdit";
import { EmployeeListAll } from "@/api/EmployeeListAll"


export default {
  name: "AttendanceLogsEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idAttLog : "",
        idEmp : "",
        checkTime : "",
        verifyMode : "",
      },
      fileList: {
      },
      selectList: {
        employeeList: [],
      },
      validateRules: {
        idAttLog: [
          {
            required: true,
            message: this.$t("attendanceLogs.validate.required.id_att_log"),
            trigger: "change",
            type: "number",
          },
        ],
        idEmp: [
          {
            required: true,
            message: this.$t("attendanceLogs.validate.required.id_emp"),
            trigger: "change",
            type: "number",
          },
        ],
        checkTime: [
          {
            required: true,
            message: this.$t("attendanceLogs.validate.required.check_time"),
            trigger: "change",
          },
        ],
        verifyMode: [
          {
            required: true,
            message: this.$t("attendanceLogs.validate.required.verify_mode"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.getEmployeeList();
      this.visible = true;
    },
    async editShow(obj) {
      this._resetData();
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.getEmployeeList();
      this.visible = true;
    },
    submit() {
      this.$refs["attendanceLogsForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new AttendanceLogsAdd();
              break;
            case "edit":
              console.log("edit");
              api = new AttendanceLogsEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 == parseInt(response.data.code)) {
              message.success(response.data.msg);
              this.$emit("updateList");
              this.visible = false;
            } else {
              message.error(response.data.msg);
            }
          });
        })
        .catch(() => {
        });
    },
    getEmployeeList() {
      const api = new EmployeeListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
            this.selectList.employeeList = response.data.data;
        } else {
            message.error(response.data.msg);
        }
      });
    },
    // reset data
    _resetData() {
      this.form = {
        idAttLog : "",
        idEmp : "",
        checkTime : "",
        verifyMode : "",
      };
    },
  },
};
</script>

<style lang="less">
</style>